"use client"
import React, { useState, useRef } from "react";
import Slider from "react-slick";
import Image from "next/image";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "slick-carousel/slick/slick.css"; // slick styles
import "slick-carousel/slick/slick-theme.css"; // slick theme
import "./imageSlider.scss";
import Accordion from "../Accordion/Accordion";

const ImageSlider = ({ images, title }) => {
  const [mainImageIndex, setMainImageIndex] = useState(0);
  const mainSliderRef = useRef(null);


  // Slick settings for the main image
  const mainSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    speed: 500,
    fade: true,
    arrows: false,
    dots: true,
    dotsClass: "slick-dots custom-dots",
    beforeChange: (current, next) => setMainImageIndex(next),
  };

  const handleThumbnailClick = (index) => {
    setMainImageIndex(index);
    mainSliderRef.current?.slickGoTo(index);
  };

  const handlePrevClick = () => {
    mainSliderRef.current?.slickPrev();
  };

  const handleNextClick = () => {
    mainSliderRef.current?.slickNext();
  };



  return (
    <div className="image-slider-container">
      {/* Thumbnails on Left */}
      {images && images.length > 0 && (
        <div className="thumbnails-section">
          <div className="thumbnails-grid">
            {images.map(({ cdn_link, id }, index) => (
              <div
                key={`thumbnail-image-${id}`}
                className={`thumbnail-item ${mainImageIndex === index ? "active" : ""}`}
                onClick={() => handleThumbnailClick(index)}
              >
                <Image
                  src={cdn_link}
                  alt={`${title} - ${index + 1}`}
                  width={120}
                  height={180}
                  className="thumbnail-image"
                />
              </div>
            ))}
          </div>

          <Accordion />
        </div>
      )}

      {/* Main Image on Right with Navigation */}
      {images && images.length > 0 && (
        <div className="main-image-wrapper">
          <div className="product-image-carousel">
            <Slider {...mainSettings} ref={mainSliderRef}>
              {images.map(({ cdn_link, id }) => (
                <div key={`product-detail-image-${id}`} className="main-image-slide">
                  <Image
                    src={cdn_link}
                    alt={title}
                    width={600}
                    height={900}
                    className="main-product-image"
                  />
                </div>
              ))}
            </Slider>
          </div>

          {/* Navigation Arrows */}
          {images.length > 1 && (
            <>
              <button className="nav-arrow prev-arrow" onClick={handlePrevClick}>
                <FiChevronLeft size={24} />
              </button>
              <button className="nav-arrow next-arrow" onClick={handleNextClick}>
                <FiChevronRight size={24} />
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageSlider;